import Head from 'next/head';
import { landingAssets } from '../landing-assets';
import { landingContent } from '../landing-content';
import {
  LANDING_CANONICAL_URL,
  LANDING_DESCRIPTION,
  LANDING_TITLE,
  serializeLandingJsonLd,
} from '../seo/landing-json-ld';

/** Head metadata for the landing page: canonical, robots, social cards, structured data. */
export function LandingSeo() {
  return (
    <Head>
      <title>{LANDING_TITLE}</title>
      <meta name="description" content={LANDING_DESCRIPTION} />
      <meta name="robots" content="index,follow" />
      {/*
        Local `public/` paths, not the S3 asset base: a favicon is a few KB, must be
        same-origin for some browsers' icon caching, and isn't the kind of heavy binary the
        S3-asset rule (see `landing-assets.ts`) exists to keep out of the repo.
      */}
      <link rel="icon" href="/favicon-512-black.png" media="(prefers-color-scheme: light)" />
      <link rel="icon" href="/favicon-512-white.png" media="(prefers-color-scheme: dark)" />
      <link rel="shortcut icon" href="/favicon-512-black.png" />
      <link rel="canonical" href={LANDING_CANONICAL_URL} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Attend" />
      <meta property="og:title" content={LANDING_TITLE} />
      <meta property="og:description" content={LANDING_DESCRIPTION} />
      <meta property="og:url" content={LANDING_CANONICAL_URL} />
      <meta property="og:image" content={landingAssets.ogImage} />
      <meta property="og:image:alt" content={landingContent.hero.imageAlt} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={LANDING_TITLE} />
      <meta name="twitter:description" content={LANDING_DESCRIPTION} />
      <meta name="twitter:image" content={landingAssets.ogImage} />
      <script
        type="application/ld+json"
        nonce={process.env.NEXT_PUBLIC_CSP_NONCE}
        dangerouslySetInnerHTML={{ __html: serializeLandingJsonLd() }}
      />
    </Head>
  );
}
